var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Lists consents for a company (paginated).
 *
 * GET /v1/api/company/{companyId}/consents
 */
export function listConsentRequests(client, params) {
    return __awaiter(this, void 0, void 0, function* () {
        const qs = new URLSearchParams();
        if (params.limit !== undefined) {
            qs.set("limit", String(params.limit));
        }
        if (params.offset !== undefined) {
            qs.set("offset", String(params.offset));
        }
        const url = client.url.joinPath(`/v1/api/company/${params.companyId}/consents`);
        url.search = qs.toString();
        const res = yield client.fetch(url, { method: "GET" });
        if (res.status > 299) {
            throw new HTTPError(res.status, { message: yield res.text(), res });
        }
        return (yield res.json());
    });
}
/**
 * Gets full details of a single consent, including approval/rejection counts
 * and whether the requesting user still needs to act.
 *
 * GET /v1/api/consents/{consentId}
 */
export function getConsentRequest(client, params) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield client.fetch(client.url.joinPath(`/v1/api/consent/${params.consentId}`), { method: "GET" });
        if (res.status > 299) {
            throw new HTTPError(res.status, { message: yield res.text(), res });
        }
        return (yield res.json());
    });
}
/**
 * Provides a list of approval actions that have been done against the consent request
 * @returns
 */
export function getEntriesConsentRequest(client, consentId) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield client.fetch(client.url.joinPath(`/v1/api/consent/${consentId}`), { method: "GET" });
        if (res.status > 299) {
            throw new HTTPError(res.status, { message: yield res.text(), res });
        }
        return (yield res.json());
    });
}
// ---------------------------------------------------------------------------
// Consent Decisions
// ---------------------------------------------------------------------------
/**
 * Registers an approval or rejection from the acting company member.
 *
 * POST /v1/api/consent/{consentId}/approve
 * POST /v1/api/consent/{consentId}/reject
 */
export function actionConsentRequest(client, params) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield client.fetch(client.url.joinPath(`/v1/api/consent/${params.consentId}/${params.action}`), Object.assign({ method: "POST" }, (params.comment
            ? {
                body: JSON.stringify({ comment: params.comment }),
                headers: { "Content-Type": "application/json" },
            }
            : {})));
        if (res.status > 299) {
            throw new HTTPError(res.status, { message: yield res.text(), res });
        }
    });
}
/**
 * Revokes (deletes) a consent request.
 *
 * DELETE /v1/api/consent/{consentId}
 */
export function revokeConsentRequest(client, params) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield client.fetch(client.url.joinPath(`/v1/api/consent/${params.consentId}`), { method: "DELETE" });
        if (res.status > 299) {
            throw new HTTPError(res.status, { message: yield res.text(), res });
        }
    });
}
// ---------------------------------------------------------------------------
// Client (Machine-to-Machine)
// ---------------------------------------------------------------------------
/**
 * Polls for the resolved status of a consent.
 * Intended for services that created the consent and want to know when it's done.
 * Authenticated via service client credentials.
 *
 * GET /v1/client/consents/{consentId}
 */
export function getClientConsentRequest(client, params) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield client.fetch(client.url.joinPath(`/v1/client/consents/${params.consentId}`), { method: "GET" });
        if (res.status > 299) {
            throw new HTTPError(res.status, { message: yield res.text(), res });
        }
        return (yield res.json());
    });
}
// ---------------------------------------------------------------------------
// Errors
// ---------------------------------------------------------------------------
export class ClientError extends Error {
}
export class HTTPError extends ClientError {
    constructor(statusCode, opts) {
        super(`[HTTPError: ${statusCode}] ${opts.message} + ${opts.res.url}`);
        this.name = "HTTPError";
        this.cause = opts.cause;
    }
}
